import type { HelpFile } from '../../types/help'
import { JobsTestIds } from '../../../testids/JobsTestIds'

export const jobsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobsTestIds.jobsPage]:
      'Alle registrierten Hintergrundprozesse — geplant, manuell und integrationsgesteuert. Zeitpläne anpassen, Jobs aktivieren oder deaktivieren und Ad-hoc-Ausführungen anstoßen.',
    [JobsTestIds.btnCreateJob]: 'Neuen Hintergrundprozess registrieren.',
    [JobsTestIds.colSchedule]: null,
    [JobsTestIds.colEnabled]: 'Gibt an, ob der Zeitplan aktiv ist — deaktivierte Jobs starten nicht automatisch, lassen sich aber manuell auslösen.',
    [JobsTestIds.colNextRun]: 'Nächste erwartete Ausführung gemäß Zeitplan und aktueller Cluster-Zeit.',
    [JobsTestIds.colLastRun]: 'Beginn der jüngsten Ausführung.',
    [JobsTestIds.colLastStatus]: 'Ergebnis der jüngsten Ausführung — Erfolg, Fehler oder noch laufend.',
  },
}
